export default __webpack_public_path__ + "static/genopets-2-d-1d0afd6911d8448067d843f7249058f5.webp";